module.exports = __webpack_public_path__ + "static/media/SP.86083778.jpg";